<template>
  <div>
    <LoadingScreen :loaded="loaded" :message="loadingMessage"></LoadingScreen>

    <ErrorBox
      v-if="errorHeading || errorContent"
      :heading="errorHeading"
      :content="errorContent"
      :fixed="errorFixed"
      @closeError="
        errorHeading = '';
        errorContent = '';
      "
    ></ErrorBox>

    <div v-if="loaded">
      <div class="p-4">
        <AddButton
          :name="$t('global.defaults.addLocal')"
          :to="'/local-admin/local-users/add'"
          @click="clearInput()"
        ></AddButton>
      </div>

      <div class="pt-4 px-4">
        <Input
          id="filter"
          v-model:value="nameFilter"
          input-type="text"
          :label="$t('inputs.filter.label')"
          class="custom-bg"
          :max-length="inputMaxLengths.name"
          :white-bg="true"
          :filter="true"
          :placeholder="$t('inputs.filter.placeholder')"
          @input="filterByName(nameFilter)"
          @clearInput="clearInput()"
        />
      </div>

      <ListItem
        v-for="user in users"
        :key="user.userId"
        icon="user"
        :name="user.name"
        :room="user.role"
        :status="user.status"
        :to="'/local-admin/local-users/' + user.userId"
        @click="clearInput()"
      ></ListItem>
      <div v-if="!users || users.length === 0" class="pb-4 text-center">
        {{
          $t("global.defaults.noUsers", {
            userType: $t("global.defaults.localUser", 2),
          })
        }}
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import AddButton from "@/components/utils/AddButton.vue";
import ListItem from "@/components/utils/ListItem.vue";
import LoadingScreen from "@/components/global/LoadingScreen.vue";
import ErrorBox from "@/components/utils/ErrorBox.vue";
import Input from "@/components/utils/Input.vue"; // @ is an alias to /src

import InputMaxLengths from "@/store/data/inputMaxLengths.json";
import { getLocalisedError } from "@/utils/apiUtils";

@Options({
  components: {
    AddButton,
    ListItem,
    LoadingScreen,
    ErrorBox,
    Input,
  },
  data() {
    return {
      users: null,
      usersOriginal: null,
      loaded: false,
      loadingMessage: this.$t("global.defaults.loading"),
      errorHeading: "",
      errorContent: "",
      errorFixed: true,
      nameFilter: "",
      inputMaxLengths: InputMaxLengths[0],
    };
  },
  mounted() {
    this.getUsers();
    document.title =
      this.$t("global.defaults.localUser", 2) +
      " - " +
      this.$t("global.defaults.browserTitle");
  },
  updated() {
    if (this.$store.state.global.update === "localUser") this.getUsers();
  },
  methods: {
    getUsers() {
      this.$store
        .dispatch("getLocalUsers")
        .then((response: Record<string, unknown>) => {
          if (response.data) {
            this.$store.dispatch("changeUpdate", "");
            this.users = this.orderByName(response.data);
            this.usersOriginal = this.orderByName(response.data);
            this.loaded = true;
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          this.loaded = true;
          this.errorHeading = "";
          this.errorContent = getLocalisedError(error);
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    orderByName(object: Array<any>) {
      return object.sort((a, b) => a.name.localeCompare(b.name));
    },
    filterByName(name: string) {
      console.log(name);
      this.users = this.usersOriginal.filter((user: any) =>
        user.name.toLowerCase().includes(name.toLowerCase())
      );
    },
    clearInput() {
      this.nameFilter = "";
      this.filterByName(this.nameFilter);
    },
  },
})
export default class LocalUsers extends Vue {}
</script>
